import { render, staticRenderFns } from "./PositionsInput.vue?vue&type=template&id=33e073e6&scoped=true"
import script from "./PositionsInput.vue?vue&type=script&lang=ts"
export * from "./PositionsInput.vue?vue&type=script&lang=ts"
import style0 from "./PositionsInput.vue?vue&type=style&index=0&id=33e073e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e073e6",
  null
  
)

export default component.exports